export const SOFTLINE_API_LIEFERANTENSTAMM = 'supplier-service/supplier/{{id}}';
export const SOFTLINE_API_LIEFERANTENSTAMM_WWS = 'supplier-service/supplier/{{id}}/wws';
export const SOFTLINE_API_LIEFERANTENSTAMM_FIBU = 'supplier-service/supplier/{{id}}/fibu';
export const SOFTLINE_API_LIEFERANTENSTAMM_RABATT =
  'supplier-service/supplier/{{id}}/supplier-discount';
export const SOFTLINE_API_LIEFERANTENSTAMM_PRODUKTGRUPPE =
  'supplier-service/supplier/{{id}}/product-categories';
export const SOFTLINE_API_LIEFERANTENSTAMM_KONTAKTE =
  'supplier-service/supplier/{{id}}/contacts';
export const SOFTLINE_API_LIEFERANTENSTAMM_EXPORT =
  'supplier-service/supplier/masterdata/export-csv';
export const SOFTLINE_API_LIEFERANTENSTAMM_IMPORT =
  'supplier-service/supplier/masterdata/import-csv';

export const SOFTLINE_API_LIEFERANTENSTAMM_DOCUMENT = 'v1/document/entities';
export const SOFTLINE_API_LIEFERANTENSTAMM_UPDATE_DOCUMENT =
  'v1/document/entities/{{documentKey}}';
export const SOFTLINE_API_LIEFERANTENSTAMM_DOCUMENT_INFO =
  'v1/document/entities/{{documentKey}}/document-information';
export const SOFTLINE_API_LIEFERANTENSTAMM_DOCUMENT_FAVORITE =
  'v1/document/entities/{{documentKey}}/favorites';
export const SOFTLINE_API_LIEFERANTENSTAMM_DOCUMENT_DOWNLOAD =
  'v1/document/entities/{{documentKey}}/download';

export const SOFTLINE_API_LIEFERANTENSTAMM_CONTACT_EDIT =
  'contact-service/contact/{{key}}';
